import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import {useTags, useProcesses, setPlan} from '../redux/plan'
const filter = createFilterOptions()

export default function Auto({freeSolo, tag, ...props}) {
  const tags = useTags()
  const [value, setValue] = React.useState(props.value);
  
  const data = typeof tags[tag] != 'undefined' ? tags[tag] : [] // just in case tag has an invalid value

  return (
    <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue)
          props.updateProcess(tag, newValue)
        }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id={props.id}
      options={data}
      getOptionLabel={(option) => {
        return option
      }}
      renderOption={(option) => option}
      freeSolo={freeSolo}
      renderInput={(params) => (
        <TextField {...params} label={props.type} 
         />
        )}
    />
  )
}
